import React from "react";
import { GetStaticProps } from "next";
import Layout from "@/components/Layout";
import { get_tdk } from "api/server/tdk";
import { Util } from "@xt/xtbase";

import Main from '@/components/Pages/App'

const { getOrigin } = Util;

interface Props {
    resolvedUrl: string;
}
const AboutUsPage: React.FC<Props> = () => {
    return (
        <Layout>
            <Main />
        </Layout>
    );
};

export default AboutUsPage;

export const getStaticProps: GetStaticProps = async (context) => {
    const resolvedUrl = "/app";
    const props: any = { resolvedUrl, theme: "dark" };

    try {
        const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
        const tdk = await get_tdk({
            params: {
                url: tdkUrl,
                languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
            },
        });
        props.tdk = tdk || {};
    } catch (error) {
        console.log("get tdk error");
        console.log(error);
        props.tdk = {};
    }

    return {
        props,
        revalidate: 60
    };
}